"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidateCommand = exports.createProcessCommand = exports.buildEvent = void 0;
const uuid_1 = require("uuid");
const gen5_datamapping_lib_1 = require("@terragotech/gen5-datamapping-lib");
const lodash_1 = __importDefault(require("lodash"));
const buildEvent = ({ commandInstance, eventType, eventVersion, eventSchemaVersion, data, aggregateType, aggregateId, }) => {
    return {
        data: (data !== null && data !== void 0 ? data : {}),
        timestamp: commandInstance.timestamp,
        type: eventType,
        source: 'Command Processor',
        version: eventVersion,
        metadata: Object.assign(Object.assign({}, commandInstance.metadata), commandInstance.securityInfo),
        eventId: uuid_1.v4(),
        aggregateId: aggregateId || commandInstance.target,
        aggregateType,
        eventSchemaVersion,
    };
};
exports.buildEvent = buildEvent;
const createProcessCommandForCopyMapping = (commandVersion, commandInstance) => [
    exports.buildEvent({
        commandInstance,
        eventType: commandVersion.cmdToEventsMapping.eventName,
        eventVersion: commandVersion.version,
        data: commandInstance.data,
        eventSchemaVersion: 1,
    }),
];
const createSources = (commandInstance) => ({
    DATA: () => commandInstance.data,
    METADATA: () => commandInstance.metadata,
    COMMAND_DATA: () => commandInstance,
});
const createEventsForOneToOneMapping = async (commandVersion, commandInstance, config, processor) => {
    const accessors = Object.assign(Object.assign({}, createSources(commandInstance)), config.accessors);
    const mappedData = await gen5_datamapping_lib_1.mapScenarios.COMMAND_EVENT_MAPPING.evaluate(commandVersion.cmdToEventsMapping.mapping, accessors, processor.configFunctions, commandInstance.timestamp, commandInstance.target);
    return [
        exports.buildEvent({
            commandInstance,
            eventType: commandVersion.cmdToEventsMapping.eventName,
            eventVersion: commandVersion.version,
            data: mappedData,
            eventSchemaVersion: mappedData['version'] || 1,
        }),
    ];
};
const createEventsForOneToManyMapping = async (commandVersion, commandInstance, config, processor) => {
    const accessors = Object.assign(Object.assign({}, createSources(commandInstance)), config.accessors);
    const mappedData = (await gen5_datamapping_lib_1.mapScenarios.COMMAND_MULTI_EVENT_MAPPING.evaluate(commandVersion.cmdToEventsMapping.mapping, accessors, processor.configFunctions, commandInstance.timestamp, commandInstance.target));
    // mappedData in this case will be an array of events(minus the metadata, since we add that here)
    return mappedData.map(mappedData => {
        return exports.buildEvent({
            commandInstance,
            eventType: mappedData.type,
            eventVersion: mappedData.version,
            aggregateId: mappedData.aggregateId,
            data: mappedData.data,
            aggregateType: mappedData.aggregateType,
            eventSchemaVersion: mappedData.version || 1,
        });
    }, []);
};
const createEvents = (commandVersion, commandInstance, config, processor) => {
    const cmdToEventsMapping = commandVersion.cmdToEventsMapping;
    if (cmdToEventsMapping.mappingType === 'COPY') {
        // This is the hack so that TS accepts that this mapping is COPY type
        return Promise.resolve(createProcessCommandForCopyMapping(Object.assign(Object.assign({}, commandVersion), { cmdToEventsMapping }), commandInstance));
    }
    else if (cmdToEventsMapping.mappingType === 'ONE-TO-ONE') {
        // This is the hack so that TS accepts that this mapping is ONE-TO-ONE type
        return createEventsForOneToOneMapping(Object.assign(Object.assign({}, commandVersion), { cmdToEventsMapping }), commandInstance, config, processor);
    }
    else if (cmdToEventsMapping.mappingType === 'ONE-TO-MANY') {
        return createEventsForOneToManyMapping(Object.assign(Object.assign({}, commandVersion), { cmdToEventsMapping }), commandInstance, config, processor);
    }
};
const createProcessCommand = (commandVersion, aggregate, config) => {
    return async (commandInstance, processor) => {
        const events = await createEvents(commandVersion, commandInstance, config, processor);
        // group all of the output events according to the aggregateId they target;
        const result = events.reduce((acc, event) => {
            var _a;
            return Object.assign(Object.assign({}, acc), { [event.aggregateId]: {
                    aggregateType: event.aggregateType || aggregate.typeName,
                    events: [...(((_a = acc[event.aggregateId]) === null || _a === void 0 ? void 0 : _a.events) || []), event],
                } });
        }, {});
        return result;
    };
};
exports.createProcessCommand = createProcessCommand;
const validateErrors = async (components, data, processor, globalAccessors, path) => {
    const messages = [];
    for (const k of Object.keys(components)) {
        const thing = components[k];
        const thisPath = path === '' ? k : path + '.' + k;
        const parts = (thisPath || '').split('.');
        const t = parts.map((part, idx) => {
            let target = data;
            let name = '';
            for (let i = 0; i < idx; i++) {
                target = lodash_1.default.get(target, parts[i]);
                name += parts[i].replace(/\[\d+\]/, '') + '.';
            }
            target = target ? lodash_1.default.get(target, part) : undefined;
            name += part.replace(/\[\d+\]/, '');
            return { [name]: target };
        });
        let formValue = { value: lodash_1.default.get(data, thisPath) };
        for (let i = 0; i < t.length; i++) {
            formValue = Object.assign(Object.assign({}, formValue), t[i]);
        }
        const accessors = Object.assign(Object.assign({}, globalAccessors), { FORM: () => {
                return data;
            }, FORMVALUE: () => formValue });
        if (thing.conditionalMap) {
            if (!(await gen5_datamapping_lib_1.mapScenarios.FORM_FIELD_CONDITIONAL.evaluate(thing.conditionalMap, accessors, processor.configFunctions)).isVisible) {
                continue;
            }
        }
        if (thing.repeats) {
            if (thing.repeats.enabled) {
                const value = lodash_1.default.get(data, thisPath);
                if (thing.repeats.max > 0 && value && value.length > thing.repeats.max) {
                    messages.push(thisPath + ' has more than the maximum number of instances');
                }
                if (thing.repeats.min > 1 && (!value || value.length < thing.repeats.min)) {
                    messages.push(thisPath + ' has less than the minimum number of instances');
                }
                for (const i in value) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    messages.push(...(await validateField(thing, data, processor, globalAccessors, thisPath + `[${i}]`)));
                }
                continue;
            }
        }
        if (thing.type === 'group') {
            messages.push(...(await validateErrors(thing.template.components, data, processor, globalAccessors, thisPath)));
        }
        if (thing.errorMap !== undefined || thing.warningMap !== undefined || thing.required !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            messages.push(...(await validateField(thing, data, processor, globalAccessors, thisPath)));
        }
    }
    return messages;
};
const validateField = async (def, data, processor, globalAccessors, path) => {
    const messages = [];
    const thing = def;
    const value = lodash_1.default.get(data, path);
    if (thing.type === 'group') {
        messages.push(...(await validateErrors(thing.template.components, data, processor, globalAccessors, path)));
    }
    else if (thing.errorMap !== undefined || thing.warningMap !== undefined || thing.required !== undefined) {
        const parts = (path || '').split('.');
        const t = parts.map((part, idx) => {
            let target = data;
            let name = '';
            for (let i = 0; i < idx; i++) {
                target = lodash_1.default.get(target, parts[i]);
                name += parts[i].replace(/\[\d+\]/, '') + '.';
            }
            target = target ? lodash_1.default.get(target, part) : undefined;
            name += part.replace(/\[\d+\]/, '');
            return { [name]: target };
        });
        let formValue = { value };
        for (let i = 0; i < t.length; i++) {
            formValue = Object.assign(Object.assign({}, formValue), t[i]);
        }
        const accessors = Object.assign(Object.assign({}, globalAccessors), { FORM: () => {
                return data;
            }, FORMVALUE: () => formValue });
        if (thing.required && (value === undefined || value === null)) {
            messages.push(path + ' is a required field');
        }
        if (thing.errorMap) {
            for (const m of thing.errorMap) {
                const err = await gen5_datamapping_lib_1.mapScenarios.FIELD_LEVEL_ERROR.evaluate(m, accessors, processor.configFunctions);
                if (err.errorMessage) {
                    messages.push(path + ':' + err.errorMessage);
                }
            }
        }
    }
    return messages;
};
const createValidateCommand = (commandVersion, config) => {
    return async (commandInstance, processor) => {
        const messages = [];
        if (commandVersion.commandType === 'FORM') {
            let currentAggregateState = {};
            if (commandInstance.target && config.accessors.OFFLINE_ATTRIB_LOOKUP) {
                const currentAggregateStateResults = (await config.accessors.OFFLINE_ATTRIB_LOOKUP(commandInstance.aggregateType, 'id', commandInstance.target, 1));
                currentAggregateState =
                    currentAggregateStateResults && currentAggregateStateResults[0] ? currentAggregateStateResults[0] : {};
            }
            const accessors = Object.assign(Object.assign(Object.assign({}, createSources(commandInstance)), config.accessors), { STATE: () => currentAggregateState });
            if (commandVersion.formDefinition.errorMaps) {
                for (const errorMapping of commandVersion.formDefinition.errorMaps) {
                    const err = await gen5_datamapping_lib_1.mapScenarios.FORM_LEVEL_ERROR.evaluate(errorMapping, Object.assign(Object.assign({}, accessors), { FORM: () => commandInstance.data }), processor.configFunctions);
                    if (err.errorMessage) {
                        messages.push(err.errorMessage);
                    }
                }
            }
            messages.push(...(await validateErrors(commandVersion.formDefinition.components, commandInstance.data, processor, accessors, '')));
        }
        return messages;
    };
};
exports.createValidateCommand = createValidateCommand;
//# sourceMappingURL=eventsUtils.js.map